export { isFileExtensionMatching } from "@finway-group/shared/lib/utils/file.utils"

export const isFileExtensionAllowed = (fileName: string, allowList: ReadonlyArray<string>) => allowList.some((allowedExt) => fileName.toLocaleLowerCase().endsWith(allowedExt))
